type Severity = "info" | "warn" | "error";

interface AppEvent {
  message: string;
  severity: Severity;
  context?: Record<string, unknown>;
}

const endpoint = import.meta.env.VITE_OBSERVABILITY_ENDPOINT;

export function captureAppEvent(event: AppEvent) {
  const payload = { product: "navioplan", at: new Date().toISOString(), ...event };
  if (event.severity === "error") console.error("[navioplan]", payload);
  else if (event.severity === "warn") console.warn("[navioplan]", payload);
  else console.info("[navioplan]", payload);
  if (!endpoint) return;
  void fetch(endpoint, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(payload),
    keepalive: true,
  }).catch(() => undefined);
}

export function captureAppError(message: string, error: unknown, context?: Record<string, unknown>) {
  captureAppEvent({ message, severity: "error", context: { ...context, error: error instanceof Error ? error.message : String(error) } });
}
